// 系统卡顿上报
export function scReport(name, type) {
  try {
    if (type === 'start') {
      window.actionStart(name);
    } else if (type === 'end') {
      window.actionEnd(name);
    }
  } catch(err) {
    console.log(err);
  }
}